<template>
    <div class="ADropdown" :class="{opened}">
        <div class="dropdown__title">
            {{ title }}: <strong @click="toggle">{{ selectedName }}</strong> <i></i>
        </div>
        <div class="dropdown__body" v-show="opened">
            <ul>
                <li v-for="option in options" @click="select(option)">{{ option.name }}</li>
            </ul>
        </div>
    </div>
</template>

<script>
import {computed, ref} from "vue";
import vClickOutside from "click-outside-vue3"

export default {
    name: "ADropdown",
    props: {
        title: String,
        options: {
            type: Array,
            validator(val) {
                return val.hasOwnProperty('name') && val.hasOwnProperty('value')
            }
        },
        modelValue: {
            type: [Number, String],
            default: 0,
        }
    },

    directives: {
        clickOutside: vClickOutside.directive
    },

    setup(props, {emit}) {
        const opened = ref(false)

        const selected = computed({
            get() {
                return props.modelValue
            },
            set(val) {
                emit('update:modelValue', val)
            }
        })

        const selectedName = computed(() => {
            return props.options.find(option => option.value === selected.value)?.name
        })

        const select = option => {
            selected.value = option.value
            opened.value = false
        }

        const toggle = () => {
            opened.value = !opened.value
        }

        const onClickOutside = () => {
            if (opened.value)
                opened.value = false
        }

        return {
            selected,
            opened,
            select,
            toggle,
            onClickOutside,
            selectedName
        }
    }
}
</script>

<style scoped lang="scss">
.ADropdown {
    position: relative;

    &.opened {
        i {
            transform: rotate(180deg);
        }
    }

    .dropdown {
        &__title {
            color: var(--c-gray-500);

            strong {
                font-weight: 600;
                font-size: rem(14);
                line-height: rem(19);
                color: #000;
                cursor: pointer;
            }

            i {
                display: inline-block;
                width: rem(15);
                height: rem(15);
                background: url("/local/templates/main/img/icons/arr.svg") no-repeat center;
                background-size: contain;
                transition: transform .3s;
                vertical-align: middle;
            }
        }

        &__body {
            position: absolute;
            z-index: 10;
            padding: rem(10);
            border-radius: rem(6);
            background: var(--c-gray-700);
            border: 1px solid var(--c-gray-600);
            width: 100%;
            max-width: rem(250);
            top: rem(30);
        }
    }

    li {
        list-style: none;
        margin-bottom: rem(10);
        cursor: pointer;

        &:nth-last-child(1) {
            margin-bottom: 0;
        }
    }
}
</style>